/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaymentRequestDto } from '../../models/payment-request-dto';
import { TransactionDto } from '../../models/transaction-dto';

export interface CollaboratorControllerCreatePayment$Params {
      body: PaymentRequestDto
}

export function collaboratorControllerCreatePayment(http: HttpClient, rootUrl: string, params: CollaboratorControllerCreatePayment$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionDto>> {
  const rb = new RequestBuilder(rootUrl, collaboratorControllerCreatePayment.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TransactionDto>;
    })
  );
}

collaboratorControllerCreatePayment.PATH = '/collaborator/payment';
